import { message as AntdMessage } from 'antd';

import {
  AutoriteFourriereControllerApi,
  DossierControllerApi,
  DossierResponseDto,
} from 'lib_api/lib/api/gen';

import {
  SubmitFunction,
  UpdateEntiteRattachementFormValues,
} from 'components/UpdateEntitesRattachements/types';
import { displayNotificationForOthersIfDoublonOrElseThrow } from 'components/UpdateEntitesRattachements/utils';
import { backAlertMessage } from 'hooks/utils/backAlertMessage';

function displaySuccessfulMessage(
  response: DossierResponseDto,
): DossierResponseDto {
  void AntdMessage.success(
    'Les entités de rattachement ont bien été modifiées',
  );
  return response;
}

function buildSubmitFunction(
  refController: AutoriteFourriereControllerApi,
  dossierController: DossierControllerApi,
  dossierId: string,
  setDossier: (dossier: DossierResponseDto) => void,
  closeModal: () => void,
): SubmitFunction {
  return (values: UpdateEntiteRattachementFormValues) => {
    return refController
      .updateEntitesRattachementAFUsingPOST(dossierId, values)
      .then(displaySuccessfulMessage)
      .catch((error: Response) =>
        displayNotificationForOthersIfDoublonOrElseThrow(
          error,
          dossierController,
          dossierId,
        ),
      )
      .then(setDossier)
      .then(closeModal)
      .catch((error: Response) => {
        void backAlertMessage(error);
      });
  };
}

export default buildSubmitFunction;
